import React from 'react';
import { Link } from 'react-router-dom';
import MUILink from '@mui/material/Link';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import HomeIcon from '@mui/icons-material/Home';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import PropTypes from 'prop-types';

function CategoryBreadCrumb({ categoryPath }) {
  return (
    <div role="presentation" onClick={(e) => e.preventDefault()} className="my-3 p-2 border-2 bg-white w-fit rounded-r-lg">
      <Breadcrumbs aria-label="breadcrumb" separator={<NavigateNextIcon className="text-main" />}>
        <MUILink
          underline="none"
          className="hover:text-main"
          sx={{ display: 'flex', alignItems: 'center' }}
          color="inherit"
          href="/home"
        >
          <Link to="/market-place">
            <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" className="text-main" />
            Home
          </Link>
        </MUILink>
        {(categoryPath.length > 0) && categoryPath.map((value) => (
          <MUILink
            underline="none"
            className="hover:text-main"
            sx={{ display: 'flex', alignItems: 'center' }}
            color="inherit"
            href="/"
            key={value.name}
          >
            <Link to={`/market-place/${value.name}-${value.id}`}>
              {value.name}
            </Link>
          </MUILink>
        ))}
      </Breadcrumbs>
    </div>
  );
}

CategoryBreadCrumb.propTypes = {
  categoryPath: PropTypes.array, //eslint-disable-line
};

CategoryBreadCrumb.defaultProps = {
  categoryPath: [],
};

export default CategoryBreadCrumb;
